import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { EmployeesTopThreadsLoadAction } from '../../domains/employeesTopThreads/actions.types';

import type { EmployeesTopThreadsLifecycle } from './types';

const initialState: EmployeesTopThreadsLifecycle = {
  fulfilled: undefined,
  rejected: undefined,
  pending: false,
};

const reducer: Reducer<EmployeesTopThreadsLifecycle, EmployeesTopThreadsLoadAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'EMPLOYEES_TOP_THREADS.LOAD_PENDING':
      return setPending();
    case 'EMPLOYEES_TOP_THREADS.LOAD_FULFILLED':
      return setFulfilled(action.payload.entities.employeesTopThreads);
    case 'EMPLOYEES_TOP_THREADS.LOAD_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
